import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";
import { UPLOAD_TYPES } from "../utils/constants";

const createTrialDocument = async ({ trialId, name, description, file }) => {
  const token = localStorage.getItem("token");

  const presignedRes = await axios.post(
    `${__API_URL__}/api/photos/get_presigned_urls/`,
    { files: [{ name: file.name, type: file.type }], uploadType: UPLOAD_TYPES.TRIAL_DOCUMENTS },
    { headers: { Authorization: `Token ${token}` } }
  );
  const [{ upload_url, blob_path, content_type }] = presignedRes.data.urls;

  const uploadRes = await fetch(upload_url, {
    method: "PUT",
    headers: { "Content-Type": content_type },
    body: file,
  });
  if (!uploadRes.ok) {
    throw new Error("Failed to upload document. Please retry.");
  }

  const res = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/documents/`,
    { name, description, blob_path },
    { headers: { Authorization: `Token ${token}` } }
  );
  return res.data;
};

const useCreateTrialDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTrialDocument,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["trial-documents", trialId] });
      toast.success("Document uploaded successfully");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to upload document");
    },
  });
};

export default useCreateTrialDocumentMutation;
